// Copyright 2026, Imprivata, Inc.  All rights reserved.

// Keys
export const SessionStorageKeys = {
  PASSWORD_EXPIRATION_DISMISSED_PORTAL: 'password-expiration-dismissed-portal',
  PASSWORD_EXPIRATION_DISMISSED_MII: 'password-expiration-dismissed-mii',
  MFA_ENROLLMENT_BANNER_DISMISSED: 'mfa-enrollment-banner-dismissed',
} as const;

// Functions

/**
 * Dismissal flags are stored as the string `'true'` and read back by comparing
 * against it. Reading and writing go through these two so the sentinel is
 * written once: a flag set with any other truthy string would read as
 * not-dismissed, and the comparison is silent about it.
 */
type DismissibleKey = (typeof SessionStorageKeys)[keyof typeof SessionStorageKeys];

const DISMISSED = 'true';

export const isDismissed = (key: DismissibleKey): boolean =>
  sessionStorage.getItem(key) === DISMISSED;

export const markDismissed = (key: DismissibleKey): void => sessionStorage.setItem(key, DISMISSED);

export const resetPasswordExpirationBanner = () => {
  sessionStorage.removeItem(SessionStorageKeys.PASSWORD_EXPIRATION_DISMISSED_PORTAL);
  sessionStorage.removeItem(SessionStorageKeys.PASSWORD_EXPIRATION_DISMISSED_MII);
};

export const resetMfaEnrollmentBanner = () => {
  sessionStorage.removeItem(SessionStorageKeys.MFA_ENROLLMENT_BANNER_DISMISSED);
};
